import { Toast } from "../../components";
import RegisterContainer from "../Register/RegisterContainer";
import ForgotPasswordContainer from "./ForgotPasswordContainer/ForgotPasswordContainer";


function ForgotPassword() {
    const getError = (data) => {
        if (data) {
            Toast.open(data, 'danger')
        }
    }
    return (
        <>
            <div id="__notification"></div>
            <RegisterContainer>
                <ForgotPasswordContainer getError={getError} />
            </RegisterContainer>
        </>
    )
}

export default ForgotPassword